export default __webpack_public_path__ + "static/media/Logo.b65183b3.png";